// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__-BWrB","tab":"ProcedureTabs_tab__2RQO0"};